import { api } from '@fno/service/global.js'

export const getSchool = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}`)
    .then(response => response.data)

export const patchSchool = ({ school }) => api
    .patch(`/v2/schools/${school.id}`, {
        data: school
    })
    .then(response => response.data)
